/** Idle session timeout defaults and role-based overrides. */

import type { SessionTimeoutConfig } from './types'

export type { SessionDialog, SessionTimeoutConfig } from './types'

export const DEFAULT_SESSION_MS = 1_800_000
export const DEFAULT_WARNING_MS = 1_500_000
export const RENTER_SESSION_MS = 14_400_000
export const RENTER_WARNING_MS = 14_220_000
/** Beacon when UI is active but no API call for 5 minutes. */
export const BEACON_IDLE_API_MS = 300_000
export const FIVE_MINUTES_MS = 300_000
export const TOKEN_POLL_INTERVAL_MS = 3_000

export const OTHER_TAB_SESSION_MESSAGE =
  'Your session has expired because you logged in from another tab or device. Click continue to refresh your session.'

export const EXPIRED_SESSION_MESSAGE =
  'Due to Inactivity your session has been expired, Please Login Again To Continue'

export function renterSessionTimeout(): SessionTimeoutConfig {
  return { sessionMs: RENTER_SESSION_MS, warningMs: RENTER_WARNING_MS }
}

export function defaultSessionTimeout(): SessionTimeoutConfig {
  return { sessionMs: DEFAULT_SESSION_MS, warningMs: DEFAULT_WARNING_MS }
}

/** Map GET /roles `session_timeout` (minutes) to ms + warning offset. */
export function sessionTimeoutFromMinutes(minutes: number): SessionTimeoutConfig {
  const sessionMs = minutes * 60 * 1000
  const warningMs =
    sessionMs > FIVE_MINUTES_MS ? sessionMs - FIVE_MINUTES_MS : sessionMs
  return { sessionMs, warningMs }
}

export function warningRemainingSeconds(sessionMs: number, warningMs: number): number {
  return Math.max(0, Math.round((sessionMs - warningMs) / 1000))
}
